import { render, staticRenderFns } from "./TheKYCModal.vue?vue&type=template&id=d5f950e6"
import script from "./TheKYCModal.vue?vue&type=script&lang=js"
export * from "./TheKYCModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports